import { DateService } from '@/coreDomainsModule/services/dateService';
import { TranslateExcelOrderBusiness } from '@/coreDomainsModule/translateExcelOrder';
import {
  RegisterOrderBusinessDurationOrderInfo,
  RegisterOrderBusinessInfo,
} from '@/coreInfrastructureModule/axios/generated/orderManage/api';

/**
 * 発注取引の登録apiのアダプタ
 */
export class BulkRegisterOrderBusinessAdapter {
  /**
   * エクセルから変換した発注取引情報をapi用に変換する
   * @param orderBusinessInfo - 編集に使用する項目
   */
  public static adapt(orderBusinessInfo: Record<string, TranslateExcelOrderBusiness>): RegisterOrderBusinessInfo[] {
    const output: RegisterOrderBusinessInfo[] = [];
    for (const orderBusiness of Object.values(orderBusinessInfo)) {
      // 発注取引情報の変換
      const adaptOrderBusiness: RegisterOrderBusinessInfo = {
        supplierNumber: orderBusiness.supplierNumber,
        supplierName: orderBusiness.supplierName,
        businessNumber: orderBusiness.businessNumber,
        businessName: orderBusiness.businessName,
        package: Number(orderBusiness.package),
        warehouseNumber: orderBusiness.warehouseNumber,
        warehouse: orderBusiness.warehouse,
        orders: [],
      };

      // 発注情報の変換を行う
      const orderArray: RegisterOrderBusinessDurationOrderInfo[] = [];
      for (const orderInfo of Object.values(orderBusiness.excelOrders)) {
        // Date型に変換して日付情報はコネコネする
        // 受注日(確定発注日)は必須ではないため、値が存在し有効な場合のみ変換する
        const fixOrderDateObj =
          orderInfo.fixOrderDate &&
          (DateService.isValidDateFormat(orderInfo.fixOrderDate) || DateService.isValidExcelDateFormat(orderInfo.fixOrderDate))
            ? new Date(orderInfo.fixOrderDate)
            : null;

        const crossDateObj = new Date(orderInfo.crossDate);
        const crossDate = isNaN(crossDateObj.getTime())
          ? undefined
          : DateService.formatIDateToISOString(DateService.convertDateToIDate(crossDateObj));

        const orderData: RegisterOrderBusinessDurationOrderInfo = {
          orderNumber: orderInfo.orderNumber,
          orderIssuedNumber: orderInfo.orderIssuedNumber,
          desiredDeliveryDate: crossDate,
          estimatedTimeOfArrival: crossDate,
          orderAmount: orderInfo.amount,
          orderStatus: orderInfo.status,
        };

        // 受注日が有効な場合のみ追加
        if (fixOrderDateObj && !isNaN(fixOrderDateObj.getTime())) {
          orderData.createdOrderDate = DateService.formatIDateToISOString(DateService.convertDateToIDate(fixOrderDateObj));
        }

        orderArray.push(orderData);
      }

      // 変換した発注情報を登録する
      adaptOrderBusiness.orders = orderArray;
      // outputに追加
      output.push(adaptOrderBusiness);
    }
    return output;
  }
}
